import { Component, Input } from '@angular/core';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
  imports: [
    MatDialogTitle,
    NgClass,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class PopupComponent {
  @Input() status = 'error';
  @Input() title = 'Meldung';
  @Input() content?: string;
  @Input() label = 'OK';
  @Input() showStatusIcon = true;

}
